import PropTypes from "prop-types";
import React, {useState} from "react";
import {Avatar, Badge, Grid, IconButton, Paper, TextField, Typography} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import cx from "clsx";
import {ChatMsgStyle} from "./defaultChatMsg.styles";
import {ThemeProvider} from "@mui/material/styles";
import ApproveDialog from "./ApproveDialog";
import ChatMsgIcon from "./ChatMsgIcon";
import ChatEditIcon from "./ChatEditIcon";

const ChatMsg = (props) => {
    const {
        avatar,
        messages,
        campaign,
        side,
        GridContainerProps,
        GridItemProps,
        AvatarProps,
        getTypographyProps,
        onApprove,
        onEditMessage, // Function to handle message edit
    } = props;

    const [approveData, setApproveData] = useState({});
    const [openApproveDialog, setOpenApproveDialog] = useState(false);
    const [editingMessageId, setEditingMessageId] = useState(null);
    const [editedMessage, setEditedMessage] = useState("");
    const [localMessages, setMessages] = useState(messages);

    const handleHiddenDialog = () => {
        setOpenApproveDialog(false);
    };


    const handleThumbClick = (id, messages, i) => {

        const approveDataObj = {
            "id": id,
            "campaign": campaign
        }

        console.log(i)

        setApproveData(approveDataObj)

        setOpenApproveDialog(true);

    };

    const handleApprove = () => {
        onApprove(approveData.id);
    };

    const handleEditClick = (msg) => {
        setEditingMessageId(msg.id);
        setEditedMessage(msg.message);
    };

    const handleEditChange = (event) => {
        setEditedMessage(event.target.value);
    };

    const handleSaveEdit = (id) => {
        onEditMessage(id, campaign, editedMessage);
        setEditingMessageId(null);
        setMessages((localMessages) =>
            localMessages.map((message) =>
                message.id === id ? {...message, message: editedMessage} : message
            )
        );
    };

    const handleCancelEdit = () => {
        setEditingMessageId(null);
    };

    const classes = ChatMsgStyle;
    const attachClass = (index) => {
        if (index === 0) return classes[`${side}First`];
        if (index === messages.length - 1) return classes[`${side}Last`];
        return "";
    };

    return (
        <ThemeProvider theme={ChatMsgStyle}>
            <Grid container spacing={1}
                  justifyContent={side === "right" ? "flex-end" : "flex-start"} {...GridContainerProps}>
                {side === "left" && (
                    <Grid item xs={1} {...GridItemProps}>
                        <Avatar
                            sx={{display: {xs: 'none', sm: 'none', md: 'flex'}}}
                            src={avatar}
                            {...AvatarProps}
                            className={cx(classes.avatar, AvatarProps.className)}
                        />
                    </Grid>
                )}
                <Grid item xs={11}>
                    {localMessages.map((msg, i) => {
                        const TypographyProps = getTypographyProps(msg, i, props);
                        let combined_styles = [classes.msg, classes[side], attachClass(i), TypographyProps.className];

                        return (
                            <div key={msg.id || i} className={classes[`${side}Row`]}>
                                <Badge color="secondary" badgeContent={msg.channel}>
                                    {editingMessageId === msg.id ? (
                                        <Paper style={{display: "flex", alignItems: "center", width: "100%"}}>
                                            <TextField
                                                multiline
                                                value={editedMessage}
                                                onChange={handleEditChange}
                                                size="small"
                                                variant="outlined"
                                                rows={4}
                                                rowsMax={6} // Limits to 6 rows max
                                                fullWidth
                                                sx={{marginRight: 1, flexGrow: 1}}
                                            />
                                            <IconButton color="primary" onClick={() => handleSaveEdit(msg.id)}>
                                                <CheckIcon/>
                                            </IconButton>
                                            <IconButton color="error" onClick={handleCancelEdit}>
                                                <CloseIcon/>
                                            </IconButton>
                                        </Paper>
                                    ) : (
                                        <Typography align={side} {...TypographyProps} sx={combined_styles}>
                                            "{msg.message}"
                                        </Typography>
                                    )}
                                    <ChatMsgIcon
                                        msg={msg}
                                        index={i}
                                        messages={messages}
                                        onApproveEvent={handleThumbClick}
                                    />
                                    <ChatEditIcon
                                        msg={msg}
                                        onClick={handleEditClick}
                                    />
                                </Badge>
                            </div>
                        );
                    })}
                </Grid>
            </Grid>
            <ApproveDialog show={openApproveDialog} data={approveData} handleClose={handleHiddenDialog}
                           onReturn={handleApprove}/>
        </ThemeProvider>
    );
};

ChatMsg.propTypes = {
    avatar: PropTypes.string,
    messages: PropTypes.arrayOf(PropTypes.object),
    side: PropTypes.oneOf(["left", "right"]),
    GridContainerProps: PropTypes.shape({}),
    GridItemProps: PropTypes.shape({}),
    AvatarProps: PropTypes.shape({}),
    getTypographyProps: PropTypes.func,
    onEditMessage: PropTypes.func.isRequired, // New prop for handling edits
};

ChatMsg.defaultProps = {
    avatar: "",
    messages: [],
    side: "left",
    GridContainerProps: {},
    GridItemProps: {},
    AvatarProps: {},
    getTypographyProps: () => ({}),
};

export default ChatMsg;
